
import { useListingWizardContext } from "@/context/ListingWizardContext";
import { Progress } from "@/components/ui/progress";
import { useIsMobile } from "@/hooks/use-mobile";

const FormProgressBar = () => {
  const { completionPercentage, formTouched, currentStep } = useListingWizardContext();
  const isMobile = useIsMobile();
  
  // Don't display any percentage if the form hasn't been touched
  const displayPercentage = formTouched ? Math.round(completionPercentage) : 0;
  
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-gray-600">Form completion</span>
        <div className={`flex items-center text-sm font-medium rounded-full border px-2 py-1 
          ${displayPercentage >= 100 
            ? "text-green-600 border-green-500 bg-green-50" 
            : "text-propertylk-blue border-propertylk-blue bg-propertylk-lightblue/20"}`}>
          {displayPercentage}%
        </div>
      </div>
      <Progress 
        value={displayPercentage} 
        indicator={displayPercentage >= 100 ? "bg-green-500" : "bg-propertylk-blue"}
        className="h-2.5 bg-gray-100"
      />
      {!isMobile && (
        <p className="text-xs text-gray-500 mt-1">
          {currentStep === 0 && "Complete the basic information to continue."}
          {currentStep === 1 && "Add details about the property."}
          {currentStep === 2 && "Add location information."}
          {currentStep === 3 && "Upload photos of your property."}
          {currentStep === 4 && "Add your contact information."}
          {currentStep === 5 && "Create an engaging title and description."}
          {currentStep === 6 && "Review your listing before submitting."}
        </p>
      )}
    </div>
  );
};

export default FormProgressBar;
